<app-uni-page
  [parent]="this"
  pageTitle="End of Day: Account-Owned Invoices"
  [bodyTemplate]="bodyTemplate"
  [footerTemplate]="footerTemplate"
>
</app-uni-page>

<ng-template #bodyTemplate>
  <uni-qb-health-banner></uni-qb-health-banner>
  <div class="qb-list-actions">
    <button
      pButton
      type="button"
      class="p-button-raised p-button-sm"
      icon="pi pi-file-plus"
      [disabled]="!qbHealth.isQbHealthy || qbHealth.isCheckingQb"
      (click)="createAccountOwnedVouchers()"
    >
      <span>Create Account-Owned Vouchers</span>
    </button>
  </div>
  <p-splitter class="w-full grow" layout="vertical" styleClass="h-full" [panelSizes]="[50, 50]">
    <ng-template pTemplate>
      <div class="flex h-full w-full flex-col overflow-hidden">
        <div class="qb-panel-title mx-4 my-2 shrink-0">Actionable Vouchers</div>
        <app-ag-grid
          [gridOptions]="actionableGridOptions"
          [rowData]="actionableActions"
          class="min-h-0 flex-1"
        ></app-ag-grid>
      </div>
    </ng-template>

    <ng-template pTemplate>
      <div class="flex h-full w-full flex-col overflow-hidden">
        <div class="qb-panel-title mx-4 my-2 shrink-0">Invoice History</div>
        <app-ag-grid
          [gridOptions]="historyGridOptions"
          [rowData]="historyInvoices"
          class="min-h-0 flex-1"
        ></app-ag-grid>
      </div>
    </ng-template>
  </p-splitter>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>
